function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".wednesday-blue_svg__cls-2{fill:#2a506a;stroke:#fff;stroke-miterlimit:10;stroke-width:28px}"));
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 124.89,
  width: 674.25,
  height: 593.93,
  rx: 55.26,
  fill: "#2a506a"
});
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "wednesday-blue_svg__cls-2",
  x: 142.35,
  y: 14,
  width: 110.89,
  height: 197.35,
  rx: 55.45
});
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 50.25,
  y: 292.17,
  width: 569.5,
  height: 368.39,
  rx: 34.59,
  fill: "#fff"
});
var _ref5 = /*#__PURE__*/React.createElement("rect", {
  className: "wednesday-blue_svg__cls-2",
  x: 423.34,
  y: 14,
  width: 110.89,
  height: 197.35,
  rx: 55.45
});
var _ref6 = /*#__PURE__*/React.createElement("text", {
  transform: "translate(109.72 547.79)",
  fontSize: 210.19,
  fontFamily: "RoundedMplus1c-Bold,\"Rounded Mplus 1c Bold\"",
  fontWeight: 700,
  fill: "#2a506a"
}, "WED");
var SvgWednesdayBlue = function SvgWednesdayBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wednesday-blue_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 674.25 718.83"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};
export default SvgWednesdayBlue;